import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import {
  createService,
  deleteService,
  getServiceList,
  updateService,
} from "../../../../redux/reducers/serviceSlice";
import { AppColors } from "../../../../util/AppColors";

function Services() {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form, setForm] = useState({ subCategory: "", category: "" });
  const [editIndex, setEditIndex] = useState(null);
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const serviceState = useSelector((state) => state.service);
  const serviceList = serviceState.list;

  useEffect(() => {
    dispatch(getServiceList());
  }, [dispatch]);

  const handleAddOrUpdate = () => {
    if (editIndex !== null) {
      const service = serviceList[editIndex];
      dispatch(updateService({ id: service.id, ...form })).then(() => {
        setOpenDrawer(false);
        setForm({ subCategory: "", category: "" });
        setEditIndex(null);
      });
    } else {
      dispatch(createService(form)).then(() => {
        setForm({ subCategory: "", category: "" });
        setOpenDrawer(false);
      });
    }
  };

  const handleEdit = (index) => {
    const service = serviceList[index];
    setForm({ subCategory: service.subCategory, category: service.category });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    dispatch(deleteService({ id: deleteId })).then(() => {
      setDelModVisible(false);
      setDeleteId(null);
    });
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteId(null);
  };

  const filteredRows = serviceList.filter(
    (row) =>
      row.subCategory.toLowerCase().includes(search.toLowerCase()) ||
      row.category.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Box p={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        flexWrap="wrap"
      >
        <Box display="flex" gap={2} mx="auto" mb={2}>
          <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          />
          <Button variant="contained" onClick={() => setOpenDrawer(true)}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Services: {filteredRows.length}
        </Typography>
      </Box>

      <Box sx={{ mt: 2, maxHeight: "60vh", overflowY: "auto" }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Subcategory</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>{row.subCategory}</TableCell>
                    <TableCell>{row.userName || "-"}</TableCell>
                    <TableCell>
                      {new Date(row.createdDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleEdit(index)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteClick(row.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Service" : "Create Service"}
            </Typography>
            <IconButton onClick={() => setOpenDrawer(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Subcategory"
            value={form.subCategory}
            onChange={(e) => setForm({ ...form, subCategory: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <TextField
            fullWidth
            select
            label="Category"
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          >
            <MenuItem value="Grooming">Grooming</MenuItem>
            <MenuItem value="Grooming2">Grooming2</MenuItem>
          </TextField>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Services;
